import * as React from "react";
import { toast } from "react-toastify";
import { Modal, ModalBody } from "reactstrap";
import {
  VendorCheckpointAssignDocument,
  vendorCheckpointDeleteFiles,
  vendorCheckpointDocumentlist,
  vendorFileUpload,
  vendorUploadSubmitCheckpointLocation,
} from "@services/checkpoint.service";
import { getValue } from "@utils/lodash";
import "./upload-modal.scss";
import qs from "query-string";
import DragAndDropFileComponent from "@_common/file-drag-drop";
import PaginationPage from "@components/pagination/pagination";
import { QueryRequestHelper } from "@_common/query-request-helper";
import { useNavigate } from "react-router-dom";
interface IUploadModalProps {
  isOpen: boolean;
  handleModal: () => void;
  getData: () => void;
  vendorInfo: object;
  mainParams: any;
  getDashboardInfo: () => void;
  handleModal2: () => void;
  selectedIndex: any;
  checkUpload: any;
  handleSubmitTask: () => void;
  releaseCycleIds: any;
}

const UploadModal: React.FunctionComponent<IUploadModalProps> = (props) => {
  const { mainParams } = props;
  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */
  const [uploadLoading, setUploadLoading] = React.useState(false);
  const [uploadedDocuments, setUploadedDocuments] = React.useState<any>([]);

  const [isLoading, setIsLoading] = React.useState(false);
  const [assignDocumentList, setAssignDocumentList] = React.useState([]);
  const [page_no, setPageNo] = React.useState(1);
  const [limit, setLimit] = React.useState(10);
  const [totalCount, setTotalCount] = React.useState(0);

  const [isLoading1, setIsLoading1] = React.useState(false);
  const [unAssignDocumentList, setUnAssignDocumentList] = React.useState([]);
  const [page_no1, setPageNo1] = React.useState(1);
  const [limit1, setLimit1] = React.useState(10);
  const [totalCount1, setTotalCount1] = React.useState(0);

  const [submitLoading, setSubmitLoading] = React.useState(false);
  const [loading1, setLoading1] = React.useState(false);

  const [selectedIds, setSelectedIds] = React.useState<any>([]);
  const [selectedIds1, setSelectedIds1] = React.useState<any>([]);

  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */
  // React.useEffect(() => {
  //   getAssignedDocumentList();
  //   getUnAssignedDocumentList();
  // }, []);

  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */

  const getAssignedDocumentList = async () => {
    let payload: any = {
      page_no: page_no ? page_no : 10,
      page_size: limit ? limit : 10,
      location_id: getValue(props, `vendorInfo.location.id`, {}),
      month: mainParams.date ? mainParams.date.split("-")[1] : "",
      year: mainParams.date ? mainParams.date.split("-")[0] : "",
      is_assigned: true,
    };
    // removing null values
    Object.keys(payload).forEach((key) => {
      if (!payload[key] || payload[key] === undefined) {
        delete payload[key];
      }
    });
    let queryRequest = qs.stringify(payload);
    setIsLoading(true);
    try {
      let resp = await vendorCheckpointDocumentlist(queryRequest);
      if (resp) {
        setIsLoading(false);
        setAssignDocumentList(getValue(resp, `data.documents`, []));
        setTotalCount(getValue(resp, `data.pagination.total`, 0));
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const getUnAssignedDocumentList = async () => {
    let payload: any = {
      page_no: page_no1 ? page_no1 : 10,
      page_size: limit1 ? limit1 : 10,
      location_id: getValue(props, `vendorInfo.location.id`, {}),
      month: mainParams.date ? mainParams.date.split("-")[1] : "",
      year: mainParams.date ? mainParams.date.split("-")[0] : "",
      is_assigned: false,
    };
    let queryRequest = qs.stringify(payload);
    setIsLoading1(true);
    try {
      let resp = await vendorCheckpointDocumentlist(queryRequest);
      if (resp) {
        setIsLoading1(false);
        setUnAssignDocumentList(getValue(resp, `data.documents`, []));
        setTotalCount1(getValue(resp, `data.pagination.total`, 0));
      } else {
        setIsLoading1(false);
      }
    } catch (error) {
      setIsLoading1(false);
    }
  };

  const handleUploadDocumnets = async (e: any) => {
    const files = Array.from(e);

    setUploadLoading(true);

    try {
      for (const item of files) {
        try {
          const formData = new FormData();
          formData.append("file", item as any);

          const resp = await vendorFileUpload(formData);

          if (resp) {
            uploadedDocuments.push(getValue(resp, `data`, {}));
          }
        } catch (error) {
          console.error("Upload error:", error);
        }
      }
    } finally {
      e = null;
      setUploadedDocuments([...uploadedDocuments]);
      setUploadLoading(false);
    }
  };

  const handleRemoveUploadedFiles = (key: number) => {
    const newFiles = [...uploadedDocuments]; // make a var for the new array
    uploadedDocuments.splice(key, 1); // remove the file from the array

    // let filtered = uploadedDocuments.filter(
    // 	(item: object) => getValue(item, `id`, "") !== id
    // );
    setUploadedDocuments([...uploadedDocuments]);
  };
  const handleSubmit = async () => {
    if (getValue(selectedIds, `length`, 0) === 0) {
      let uploadIds =
        getValue(uploadedDocuments, `length`, 0) > 0
          ? uploadedDocuments.map((item: any) => item.id)
          : [];
      // let ids =
      // 	getValue(selectedIds, `length`, 0) > 0 &&
      // 	selectedIds.map((item: any) => {
      // 		return item.split(":")[1];
      // 	});
      // let allIds =
      // 	getValue(uploadIds, `length`, 0) > 0 ? uploadIds : [].concat(ids);

      try {
        setSubmitLoading(true);
        let payload = {
          vendor_checkpoint: [
            {
              id: getValue(props, `vendorInfo.id`, ""),
              audit_cycle_id: getValue(props, `releaseCycleIds`, ""),
              document_ids:
                getValue(uploadIds, `length`, 0) > 0 ? uploadIds : [],
            },
          ],
        };
        let resp = await vendorUploadSubmitCheckpointLocation(payload);
        if (resp) {
          setSubmitLoading(false);
          props.handleModal();
          props.getData();
          props.getDashboardInfo();
          toast.success("Uploaded successfully");
        } else {
          props.getData();
          setSubmitLoading(false);
        }
      } catch (error) {
        setSubmitLoading(false);
      }
    } else {
      toast.error("Please Remove Assigned/Unassigned Documents to Continue");
    }
  };

  const handleSubmitWithoutClose = async () => {
    if (getValue(selectedIds, `length`, 0) === 0) {
      let uploadIds =
        getValue(uploadedDocuments, `length`, 0) > 0
          ? uploadedDocuments.map((item: any) => item.id)
          : [];
      // let ids =
      // 	getValue(selectedIds, `length`, 0) > 0 &&
      // 	selectedIds.map((item: any) => {
      // 		return item.split(":")[1];
      // 	});
      // let allIds =
      // 	getValue(uploadIds, `length`, 0) > 0 ? uploadIds : [].concat(ids);

      try {
        setSubmitLoading(true);
        let payload = {
          vendor_checkpoint: [
            {
              id: getValue(props, `vendorInfo.id`, ""),
              document_ids:
                getValue(uploadIds, `length`, 0) > 0 ? uploadIds : [],
            },
          ],
        };
        let resp = await vendorUploadSubmitCheckpointLocation(payload);
        if (resp) {
          setSubmitLoading(false);
          props.getData();
          props.getDashboardInfo();
          toast.success("Uploaded successfully");
        } else {
          props.getData();
          setSubmitLoading(false);
        }
      } catch (error) {
        setSubmitLoading(false);
      }
    } else {
      toast.error("Please Remove Assigned/Unassigned Documents to Continue");
    }
  };

  const updateUnAssignedFiles = async () => {
    if (getValue(uploadedDocuments, `length`, 0) === 0) {
      try {
        setLoading1(true);
        let ids =
          getValue(selectedIds, `length`, 0) > 0
            ? selectedIds.map((item: any) => {
                return item.split(":")[0];
              })
            : [];

        let ids1 =
          getValue(selectedIds1, `length`, 0) > 0
            ? selectedIds1.map((item: any) => {
                return item.split(":")[0];
              })
            : [];
        let allIds = ids.concat(ids1);
        let payload = {
          vendor_checkpoint_id: getValue(props, `vendorInfo.id`, ""),
          vc_document_ids: allIds,
        };
        let resp = await VendorCheckpointAssignDocument(payload);
        if (resp) {
          setLoading1(false);
          toast.success("Updated successfully");
          props.handleModal();
          props.getData();
          getAssignedDocumentList();
          getUnAssignedDocumentList();
        } else {
          setLoading1(false);
        }
      } catch (error) {
        setLoading1(false);
      }
    } else {
      toast.error("Please Remove Uploaded Documents to Continue");
    }
  };

  const handleRemovedFiles = async () => {
    let ids =
      getValue(selectedIds1, `length`, 0) > 0
        ? selectedIds1.map((item: any) => {
            return item.split(":")[0];
          })
        : [];
    let resp = await vendorCheckpointDeleteFiles({ ids: ids });
    if (resp) {
      toast.success(getValue(resp, `message`, ""));
      getAssignedDocumentList();
      getUnAssignedDocumentList();
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                               Onchange section                             */
  /* -------------------------------------------------------------------------- */
  const handleCheckBox = (id: string) => {
    let ids = selectedIds.filter((item: any) => id === item);
    if (ids.length === 0) {
      selectedIds.push(id);
      setSelectedIds([...selectedIds]);
    } else {
      let filtered = selectedIds.filter((item: any) => id !== item);
      setSelectedIds(filtered);
    }
  };
  const handleCheckBox1 = (id: string) => {
    let ids = selectedIds1.filter((item: any) => id === item);
    if (ids.length === 0) {
      selectedIds1.push(id);
      setSelectedIds1([...selectedIds1]);
    } else {
      let filtered = selectedIds1.filter((item: any) => id !== item);
      setSelectedIds1(filtered);
    }
  };
  const handleRemoveUploadedFiles1 = (id: string, index: number) => {
    let filtered = assignDocumentList.filter(
      (item: any, key: any) => index !== key
    );
    setAssignDocumentList(filtered);
  };

  /* -------------------------------------------------------------------------- */
  /*                               Pagination section                           */
  /* -------------------------------------------------------------------------- */

  let navigate = useNavigate();

  const handleChangePagination = (page_no: any) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    setPageNo(page_no);
    // const urlSearchParams = new URLSearchParams(window.location.search);
    // const params = Object.fromEntries(urlSearchParams.entries());
    // let payload: any = {
    // 	...params,
    // 	page_no: page_no,
    // };
    // const queryRequest = QueryRequestHelper(payload);
    // navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const handleChangePagination1 = (page_no: any) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    setPageNo1(page_no);
  };

  const fileTypes = [
    "PDF",
    "JPEG",
    "XLSX",
    "CSV",
    "XLSM",
    "XLX",
    "JPG",
    "PNG",
    "DOC",
    "DOCX",
    'ZIP',
  ];
  console.log(props.vendorInfo, "--props--->");
  return (
    <div className="attach-files-wrapper">
      <Modal
        isOpen={getValue(props, `isOpen`, "")}
        toggle={getValue(props, `isOpen`, "")}
        centered
        size="lg"
      >
        <div className="attach-files-wrapper__title-section d-flex justify-content-between">
          <h3 className="attach-files-wrapper__title">Attach File</h3>
          <div className="d-flex justify-content-end">
            {/* <button
							className="ascent-button ascent-button--header-buttons ascent-button--primary mx-3"
							onClick={() => props.handleModal()}
						>
							Cancel
						</button> */}
            <img
              src="/images/close-red.svg"
              className="cursor-pointer"
              width={25}
              onClick={props.handleModal}
            />
          </div>
        </div>
        <ModalBody>
          <div>
            <div>
              <h6 className="comments-popup__vendor-name">Task ID</h6>
              <p className="comments-popup__vendor-text">
                {getValue(props, `vendorInfo.task_id`, "")}
              </p>
            </div>
            <div className="comments-popup__vendor-details">
              <h6 className="comments-popup__vendor-name">Legislation</h6>
              <p className="comments-popup__vendor-text">
                {getValue(
                  props,
                  `vendorInfo.checkpoint.legislation.legislation_name`,
                  ""
                )}
              </p>
            </div>
          </div>
          <div>
            {uploadLoading ? (
              <label className="input-file-label w-100 text-center cursor-pointer mb-4">
                <input
                  // type={'file'}
                  // onChange={handleUploadDocumnets}
                  multiple
                  className="d-none"
                />
                <div className="custom-inputfile">
                  <img
                    src="/images/input-file.png"
                    className="img-fluid mb-2"
                    height={40}
                    width={40}
                  />
                  <p className="custom-inputfile__text">Please wait...</p>
                </div>
              </label>
            ) : (
              <div className="input-file-label w-100 text-center cursor-pointer mb-4">
                {/* <input
							type={'file'}
							onChange={handleUploadDocumnets}
							multiple
							className="d-none"
						/> */}
                {/* <FileUploader
									handleChange={handleUploadDocumnets}
									name="file"
									types={fileTypes}
									multiple
									// className="d-none"
									classes="bulk-upload_drag-n-drop-wrapper position-absolute"
								/>
								<div className="custom-inputfile">
									<img
										src="/images/input-file.png"
										className="img-fluid mb-2"
										height={40}
										width={40}
									/>
									<p className="custom-inputfile__text">
										Drag & Drop Files here
									</p>
									<p className="custom-inputfile__text">OR</p>
									<a href="#0">Browse Files</a>
								</div> */}
                <DragAndDropFileComponent
                  uploadFile={handleUploadDocumnets}
                  name="file"
                  types={fileTypes}
                  multiple
                  // className="d-none"
                  classes="bulk-upload_drag-n-drop-wrapper position-absolute"
                />
              </div>
            )}
            {getValue(uploadedDocuments, `length`, 0) > 0 && (
              <div className="d-flex justify-content-between">
                <div></div>
                <div className="d-flex">
                  {submitLoading ? (
                    <button className="ascent-button ascent-button--header-buttons ascent-button--primary">
                      Please wait...
                    </button>
                  ) : (
                    <button
                      className="ascent-button ascent-button--header-buttons ascent-button--primary"
                      onClick={handleSubmit}
                      disabled={getValue(uploadedDocuments, `length`, 0) === 0}
                    >
                      {"Save Uploaded files"}
                    </button>
                  )}
                  {getValue(props, "vendorInfo.audit_status", "") !==
                    "PENDING_AUDIT" && (
                    <button
                      className="ascent-button ascent-button--secondary ascent-button--checkpoint d-flex align-items-center ms-3"
                      // onClick={props.handleModal2}
                      // onClick={() => {
                      // 	handleSubmit();
                      // 	props.handleModal2();
                      //   }}

                      onClick={() => {
                        // if (props.checkUpload.some((item: any) => item.upload_status === "NOT_UPLOADED")) {
                        handleSubmit();
                        props.handleSubmitTask();
                        // } else {
                        //   props.handleModal2();
                        // }
                      }}
                      disabled={
                        props.selectedIndex.length === 0 ||
                        getValue(mainParams, `listenable`, "") === "0"
                      }
                    >
                      Submit for Audit Review
                    </button>
                  )}
                </div>
              </div>
            )}
            {getValue(uploadedDocuments, `length`, 0) > 0 && (
              <div className="mb-3">
                <h3 className="attach-files-wrapper__select">
                  Select from uploaded files
                </h3>
                {getValue(uploadedDocuments, `length`, 0) > 0 ? (
                  uploadedDocuments.map((item: object, key: number) => {
                    return (
                      <div
                        key={key}
                        className="attach-files-wrapper__files cursor-pointer d-flex justify-content-between"
                      >
                        <p>
                          {getValue(item, `name`, "")}
                          {getValue(item, `extension`, "")}
                        </p>
                        <div>
                          <img
                            src="/images/close-black.svg"
                            className="img-fluid cursor-pointer"
                            onClick={() => handleRemoveUploadedFiles(key)}
                          />
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <p className="text-center mt-2"> No Data Found</p>
                )}
              </div>
            )}

            {(getValue(assignDocumentList, `length`, 0) > 0 ||
              getValue(unAssignDocumentList, `length`, 0) > 0) && (
              <div className="d-flex justify-content-between">
                <div></div>
                <div className="d-flex">
                  <button
                    onClick={updateUnAssignedFiles}
                    disabled={
                      loading1 ||
                      (getValue(selectedIds, `length`, 0) === 0 &&
                        getValue(selectedIds1, `length`, 0) === 0)
                    }
                    className="ascent-button ascent-button--primary ascent-button--checkpoint d-flex align-items-center"
                  >
                    {loading1
                      ? "Please Wait..."
                      : "Submit from Assigned/Un Assigned"}
                  </button>
                </div>
              </div>
            )}

            {getValue(assignDocumentList, `length`, 0) > 0 && (
              <div className="d-none">
                <h3 className="attach-files-wrapper__select">
                  Select from the assigned files
                </h3>
                {isLoading ? (
                  <p className="text-center">Please Wait...</p>
                ) : getValue(assignDocumentList, `length`, 0) > 0 ? (
                  assignDocumentList.map((item: object, key: number) => {
                    return (
                      <>
                        <div
                          key={key}
                          className="attach-files-wrapper__files cursor-pointer d-flex justify-content-between"
                        >
                          <div className="d-flex">
                            <label
                              className="m-0 position-relative"
                              htmlFor={`detailsCheckbox-${key}`}
                            >
                              <input
                                type="checkbox"
                                className="default-checkbox"
                                id={`detailsCheckbox-${key}`}
                                onChange={() =>
                                  handleCheckBox(
                                    `${getValue(item, `id`, "")}:${getValue(
                                      item,
                                      `document.id`,
                                      ""
                                    )}`
                                  )
                                }
                                checked={selectedIds.includes(
                                  `${getValue(item, `id`, "")}:${getValue(
                                    item,
                                    `document.id`,
                                    ""
                                  )}`
                                )}
                              />
                              <div className="custom-checkbox">
                                <img
                                  src="/images/uploaded-details/tick.svg"
                                  className="img-fluid uploaded-tick"
                                />
                              </div>
                            </label>
                            <p style={{ marginLeft: "20px" }}>
                              {getValue(item, `document.name`, "")}
                            </p>
                          </div>
                          {/* <img
								src="/images/close-black.svg"
								className="img-fluid cursor-pointer"
								onClick={() =>
									handleRemovedFiles(getValue(item, `id`, ""), key)
								}
							/> */}
                        </div>
                      </>
                    );
                  })
                ) : (
                  <p className="text-center mt-2"> No Data Found</p>
                )}
                <div className="pagination-wrapper mb-3">
                  {totalCount > 10 ? (
                    <PaginationPage
                      totalCount={totalCount}
                      limit={limit}
                      pageNumber={page_no}
                      handleChangePagination={handleChangePagination}
                      showLimit={"false"}
                    />
                  ) : (
                    <p className="show-rows-count mt-3 d-flex">
                      Total Count:&nbsp;&nbsp;{" "}
                      <p style={{ color: "rgb(13, 110, 253)" }}>{totalCount}</p>
                    </p>
                  )}
                </div>
              </div>
            )}

            {getValue(unAssignDocumentList, `length`, 0) > 0 && (
              <div className="mb-3 d-none">
                <div className="d-flex justify-content-between">
                  <h3 className="attach-files-wrapper__select">
                    Select from the unassigned files
                  </h3>

                  <button
                    onClick={handleRemovedFiles}
                    disabled={getValue(selectedIds1, `length`, 0) === 0}
                    className="ascent-button ascent-button--primary ascent-button--checkpoint"
                  >
                    {/* {loading1 ? "Please Wait..." : "Delete"} */}
                    Delete
                  </button>
                </div>
                {isLoading1 ? (
                  <p className="text-center">Please Wait...</p>
                ) : getValue(unAssignDocumentList, `length`, 0) > 0 ? (
                  unAssignDocumentList.map((item: object, key: number) => {
                    return (
                      <>
                        <div
                          key={key}
                          className="attach-files-wrapper__files cursor-pointer d-flex justify-content-between"
                        >
                          <div className="d-flex">
                            <label
                              className="m-0 position-relative"
                              htmlFor={`detailsCheckboxNew-${key}`}
                            >
                              <input
                                type="checkbox"
                                className="default-checkbox"
                                id={`detailsCheckboxNew-${key}`}
                                onChange={() =>
                                  handleCheckBox1(
                                    `${getValue(item, `id`, "")}:${getValue(
                                      item,
                                      `document.id`,
                                      ""
                                    )}`
                                  )
                                }
                                checked={selectedIds1.includes(
                                  `${getValue(item, `id`, "")}:${getValue(
                                    item,
                                    `document.id`,
                                    ""
                                  )}`
                                )}
                              />
                              <div className="custom-checkbox">
                                <img
                                  src="/images/uploaded-details/tick.svg"
                                  className="img-fluid uploaded-tick"
                                />
                              </div>
                            </label>
                            <p style={{ marginLeft: "20px" }}>
                              {getValue(item, `document.name`, "")}
                            </p>
                          </div>
                          {/* <img
														src="/images/close-black.svg"
														className="img-fluid cursor-pointer"
														onClick={() =>
															handleRemovedFiles(getValue(item, `id`, ""), key)
														}
													/> */}
                        </div>
                      </>
                    );
                  })
                ) : (
                  <p className="text-center mt-2"> No Data Found</p>
                )}
                <div className="pagination-wrapper mb-3">
                  {totalCount1 > 10 ? (
                    <PaginationPage
                      totalCount={totalCount1}
                      limit={limit1}
                      pageNumber={page_no1}
                      handleChangePagination={handleChangePagination1}
                      showLimit={"false"}
                    />
                  ) : (
                    <p className="show-rows-count mt-3 d-flex">
                      Total Count:&nbsp;&nbsp;{" "}
                      <p style={{ color: "rgb(13, 110, 253)" }}>
                        {totalCount1}
                      </p>
                    </p>
                  )}
                </div>
              </div>
            )}
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default UploadModal;
